import React, { Component } from 'react'
import { Row, Col, Modal } from 'antd'
import DTI from 'dom-to-image'
import bottomLogo from 'assets/image/footer-logo@3x.png'
import imgQrcode from 'assets/image/qrcode.jpg'
import Keyword from './keyword'
import { randomNum, selectFromArray } from 'helper'

class Result extends Component {
  state = {
    points: 0,
    sspaiIndex: '0%',
    tags: [],
    username: '你',
    imageData: '',
    modalVisible: false,
  }

  componentDidMount() {
    const tagsStorage = window.localStorage.getItem('sspai_tags')
    const points = Number(window.localStorage.getItem('sspai_point'))
    const username = window.localStorage.getItem('sspai_username')

    let tags
    try {
      tags = JSON.parse(tagsStorage)
    } catch (err) {
      tags = []
    }

    tags = selectFromArray(tags, 5)
    const sspaiIndex = Math.round((points / 10 + randomNum(0.01, 0.09, true)) * 100) + '%'

    this.setState({
      tags,
      points,
      sspaiIndex,
      username,
    })
  }

  showModal = () => {
    this.setState({
      modalVisible: true,
    })
  }

  hideModal = () => {
    this.setState({
      modalVisible: false,
    })
  }

  saveAsImage = async () => {
    const node = document.getElementById('result-view')
    try {
      const imageData = await DTI.toPng(node, { bgcolor: '#414555' })
      this.setState(
        {
          imageData,
        },
        () => {
          this.showModal()
        },
      )
    } catch (err) {
      console.warn(err)
      alert('抱歉，您的设备不支持图片生成')
    }
  }

  jumpOnClickLogo = () => {
    window.location.replace('https://sspai.com/page/2018')
  }

  render() {
    const { sspaiIndex, tags, username, modalVisible, imageData } = this.state

    return (
      <React.Fragment>
        <Modal
          style={{ top: 0 }}
          bodyStyle={{ padding: 0 }}
          title='长按下方图片来保存和分享'
          footer={null}
          visible={modalVisible}
          onCancel={this.hideModal}
        >
          <Row>
            <Col>
              <img style={{ maxWidth: '100%' }} src={imageData} alt='结果图片' />
            </Col>
          </Row>
        </Modal>

        <Row id='result-view'>
          <Col>
            <Row style={{ width: 300, margin: '120px auto 0' }}>
              <Col>
                <Row style={{ fontSize: 16, fontWeight: 700 }}>
                  <Col>
                    <span
                      style={{
                        display: 'inline-block',
                        padding: '2px 10px',
                        marginRight: 8,
                        fontSize: 14,
                        backgroundColor: '#eb5757',
                        color: '#ffffff',
                      }}
                    >
                      {username}
                    </span>
                    <span style={{ color: '#ffffff', opacity: 0.6 }}>的少数派指数为</span>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <span
                      style={{
                        display: 'inline-block',
                        fontSize: 72,
                        fontWeight: 700,
                      }}
                    >
                      {sspaiIndex}
                    </span>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <span style={{ fontSize: 12, color: '#d8d8d8' }}>这是我的关键词</span>{' '}
                    <span style={{ color: '#eb5757' }}>#关键词#</span>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row style={{ marginTop: 20 }}>
              <Col>
                {tags.map((keyword, index) => (
                  <Keyword key={index} index={index} keyword={keyword} />
                ))}
              </Col>
            </Row>

            <Row style={{ width: 300, margin: '40px auto 0' }}>
              <Col>
                <Row>
                  <Col span={12}>
                    点击查看少数派 2018 年度盘点{' '}
                    <span role='img' aria-label='point-down'>
                      👇
                    </span>
                  </Col>
                  <Col span={3} />
                  <Col span={9}>轻触二维码保存图片</Col>
                </Row>

                <Row style={{ marginBottom: 70 }}>
                  <Col span={12}>
                    <img
                      style={{ width: 130, marginTop: 30 }}
                      onClick={this.jumpOnClickLogo}
                      src={bottomLogo}
                      alt='logo'
                    />
                  </Col>

                  <Col span={3} />

                  <Col span={9}>
                    <img
                      style={{ width: '100%', marginTop: 30 }}
                      src={window.sspaiStaticRoot + imgQrcode}
                      onClick={this.saveAsImage}
                      alt='qrcode'
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </React.Fragment>
    )
  }
}

export default Result
